import { isServer } from '../../utils/isServer';

const CID = '1bf35e8b-3d55-48a6-aef8-0ebfdd277df7';

export const loadElementScript = (parent = document.head) => {
  if(isServer()) {
    return Promise.reject('Cannot load Connatix player on server');
  }
  return new Promise((resolve, reject) => {
    if(window.cnx) {
      resolve(window.cnx);
    }
    window.cnx = {}, window.cnx.cmd = [];
    const cnxUrl = `//cd.connatix.com/connatix.player.js?cid=${CID}`;
    const script = document.createElement('script');
    script.onload = () => resolve(window.cnx);
    script.onerror = () => {
      reject(`Script at url ${cnxUrl} failed to load`);
    };
    script.src = cnxUrl;
    script.async = true;
    script.type = 'text/javascript';
    parent.appendChild(script);
  });
};
